import { render, staticRenderFns } from "./updatalist.vue?vue&type=template&id=6a319b5c&scoped=true"
import script from "./updatalist.vue?vue&type=script&lang=js"
export * from "./updatalist.vue?vue&type=script&lang=js"
import style0 from "./updatalist.vue?vue&type=style&index=0&id=6a319b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a319b5c",
  null
  
)

export default component.exports